export enum ECartStep {
  CART = 1,
  SIDEDISHES = 2,
  CROSS_SELLING = 3,
}
